import { actionTypes } from '../constants';
import { API } from '../../../vendor/api';
import { selectInstitution, setInstitution, ExtensionTypes } from '../../../store/features/system';
import { uninstallExtension as uninstall } from '../../extensions-framework';
import { setHasNewExtensions, loadAndInstallExtensions } from '../../extensions-framework/actions';
import { getAngularServiceOrUndefined, getAngularService, } from '../../core/helpers';
import { AngularServices } from '../../extensions-framework/angular-integration/integration-types';
import { RootScopeEvents } from '../../../common/services/root-scope-types';
import { addToast } from '../../core/actions';
import { ToastType } from '../../core/constants';
import { localeService } from '../../core';
export const TRANSLATIONS = {
    default: {
        [ExtensionTypes.installed]: {
            notifyMsgKey: 'account.marketplace.successfully-added',
        },
        [ExtensionTypes.uninstalled]: {
            notifyMsgKey: 'account.marketplace.successfully-removed',
        },
    },
    institution: {
        [ExtensionTypes.installed]: {
            notifyMsgKey: 'account.marketplace.successfully-added-to-clinic',
        },
        [ExtensionTypes.uninstalled]: {
            notifyMsgKey: 'account.marketplace.successfully-removed-from-clinic',
        },
    }
};
export const clearExtensionReducer = () => (dispatch) => {
    dispatch({ type: actionTypes.CLEAR_EXTENSION });
};
export const installExtension = (extension) => async (dispatch, getState) => {
    try {
        const institution = selectInstitution(getState());
        const institutionParam = {
            ...(institution && { institutionId: institution.id }),
        };
        const payload = await API.extensions.install(institutionParam, extension.id);
        const message = localeService.formatMessageById(institution ? TRANSLATIONS.institution.installed.notifyMsgKey : TRANSLATIONS.default.installed.notifyMsgKey);
        dispatch(addToast(ToastType.success, message, 3000));
        dispatch({ type: actionTypes.SET_EXTENSION, payload });
    }
    catch (error) {
        console.error('error in action "installExtension"', error);
        const errorMessage = localeService.formatMessageById('notification.extensions-marketplace.server-error');
        dispatch(addToast(ToastType.error, errorMessage));
    }
    await dispatch(loadAndInstallExtensions());
};
export const addAwareness = (id) => async (dispatch, getState) => {
    try {
        const institution = selectInstitution(getState());
        const institutionParam = {
            ...(institution && { institutionId: institution.id }),
        };
        await API.extensions.awareness(institutionParam, id);
    }
    catch (error) {
        console.error('Error in action "addAwareness"', error);
    }
};
export const uninstallExtension = (extension) => async (dispatch, getState) => {
    try {
        uninstall(extension.name);
        const institution = selectInstitution(getState());
        const institutionParam = {
            ...(institution && { institutionId: institution.id }),
        };
        const payload = await API.extensions.uninstall(institutionParam, extension.id);
        const message = localeService.formatMessageById(institution ? TRANSLATIONS.institution.uninstalled.notifyMsgKey : TRANSLATIONS.default.uninstalled.notifyMsgKey);
        dispatch(addToast(ToastType.success, message, 3000));
        dispatch({ type: actionTypes.SET_EXTENSION, payload });
    }
    catch (error) {
        console.error('Error in action "uninstallExtension"', error);
        const errorMessage = localeService.formatMessageById('notification.extensions-marketplace.server-error');
        dispatch(addToast(ToastType.error, errorMessage));
    }
    await dispatch(loadAndInstallExtensions());
};
export const getExtensionsList = () => async (dispatch, getState) => {
    try {
        const institution = selectInstitution(getState());
        const params = {
            ...(institution && { institutionId: institution.id }),
        };
        const extensions = await API.extensions.getAll(params);
        dispatch({
            type: actionTypes.SET_ALL_EXTENSIONS_LIST,
            payload: extensions,
        });
        dispatch(setHasNewExtensions(extensions));
    }
    catch (error) {
        console.error('Error in action "getExtensionsList":', error);
        const errorMessage = localeService.formatMessageById('notification.extensions-marketplace.server-error');
        dispatch(addToast(ToastType.error, errorMessage));
    }
};
export const getExtensionById = (id) => async (dispatch, getState) => {
    try {
        const institution = selectInstitution(getState());
        const params = {
            ...(institution && { institutionId: institution.id }),
        };
        const extension = await API.extensions.getExtensionById(params, id);
        dispatch({
            type: actionTypes.SET_EXTENSION,
            payload: extension,
            meta: {
                key: 'extension',
            },
        });
    }
    catch (error) {
        console.error('Error in action "getExtensionById"', error);
        const errorMessage = localeService.formatMessageById('notification.extensions-marketplace.server-error');
        dispatch(addToast(ToastType.error, errorMessage));
    }
};
export const updatePublicAttributes = (institution) => async (dispatch) => {
    try {
        const extensionsService = getAngularServiceOrUndefined('extensionsService');
        const institutionAccess = {
            institutionAccess: institution.institutionAccess,
        };
        await API.extensions.updatePublicAttributes(institutionAccess, institution.id);
        dispatch(setInstitution(institution));
        extensionsService.accessService.cache = {};
        extensionsService.accessService.mediator.emit('changed');
    }
    catch (e) {
        const errorMessage = localeService.formatMessageById('notification.extensions-marketplace.server-error');
        dispatch(addToast(ToastType.error, errorMessage));
        console.error('Error in action "updatePublicAttributes":', e);
    }
};
export const marketplaceClosed = () => (_dispatch) => {
    const rootScope = getAngularService(AngularServices.RootScope);
    rootScope.$emit(RootScopeEvents.MARKETPLACE.CLOSED);
};
export const marketplaceExtensionViewed = ({ id: extensionName, isFake: fakedoor }) => (_dispatch) => {
    const rootScope = getAngularService(AngularServices.RootScope);
    rootScope.$emit(RootScopeEvents.MARKETPLACE.EXTENSION_VIEWED, {
        extensionName,
        fakedoor,
    });
};
export const marketplaceExtensionVoted = (extensionName, rating) => (_dispatch) => {
    const rootScope = getAngularService(AngularServices.RootScope);
    rootScope.$emit(RootScopeEvents.MARKETPLACE.EXTENSION_VOTED, {
        extensionName,
        rating,
    });
};
export const marketplaceExtensionClosed = ({ id: extensionName, isFake: fakedoor }) => (_dispatch) => {
    const rootScope = getAngularService(AngularServices.RootScope);
    rootScope.$emit(RootScopeEvents.MARKETPLACE.EXTENSION_CLOSED, {
        extensionName,
        fakedoor,
    });
};
